export default {
  reportings: {
    title: "Reporting",
    subtitle: "Please adjust the filters below to view your reporting results",
    createReport: {
      button: "Create Excel file",
      title:
        "{reportStatusCode, plural, =3 {The excel file is generated} =2 {Your request to create the excel file is still in progress} =1 {Your request to create the excel file is still in progress} =0 {Do you want to create the excel file?} other {Sorry, something went wrong}}",
      content:
        "{reportStatusCode, plural, =3 {The file download link will be sent to your email, {email}. Please contact our customer service if you do not receive the email or face issues downloading the file.} =2 {Rest assured that once the file is ready, we will send the file download link to your email.} =1 {Rest assured that once the file is ready, we will send the file download link to your email.} =0 {Preparing the excel file might take a while. Once it is ready, we will send the file download link to your email, {email}. Please contact our customer service if you did not receive the email or face issues downloading the file.} other {Please speak with your office administration.}}",
      ok: "{reportStatusCode, plural, =0 {Create} other {Got it}}",
      cancel: "Cancel",
    },
    radioOptButton: {
      buy: "Buy",
      rent: "Rent",
      both: "All",
      sale: "Sale",
      residential: "Residential",
      commercial: "Commercial",
    },
    typeButton: {
      pro: "PRO",
      agentnet: "AgentNet",
      tooltip: {
        agentNet: {
          title: "AgentNet Listing Insight",
          content:
            "You can now easily view your AgentNet Listing Insight in here.",
        },
      },
    },
    durationButton: {
      oneWeek: "1W",
      oneMonth: "1M",
      threeMonth: "3M",
      sevenDays: "7D",
      thirtyDays: "30D",
    },
    tabs: {
      listings: "Listings",
      districts: "Districts",
      area: "City",
      estate: "Estates",
      building: "Building",
      users: "Users",
      township: "Township",
    },
    common: {
      listings: "Listings",
      impressions: "Impressions",
      pageViews: "Page views",
      enquiries: "Enquiries",
      emptyHeader: "No reporting result found.",
      emptySubHeader:
        "Try adjusting the filters to view your reporting results.",
      errorHeader: "Sorry, something went wrong.",
      errorSubHeader: "Please speak with your office administration.",
      returnTop: "Return to the top of results",
      count: "Search",
      emptyColumn: "Please select the data that you want to see.",
      expandTable: "Expand table",
    },
    snapshot: {
      title: "Performance snapshot",
      buy: "Buy",
      rent: "Rent",
      all: "All",
      description1W: " listings for a 1 week time period",
      description1M: " listings for a 1 month time period",
      description3M: " listings for a 3 months time period",
      propertySaves: "Property saves",
      photoViews: "Photo views",
      shares: "Shares",
      showBreakdown: "Show breakdown",
      hideBreakdown: "Hide breakdown",
      phone: "Phone Number Reveal",
      whatsapp: "WhatsApp",
      email: "Email",
      chartTitle: "Enquiries <br/> Breakdown",
      note: "Note: <b>Premium</b> and <b>Feature</b> upgrades help your listings rank higher in the search results.",
      noteMY:
        "Note: <b>Premium</b> and <b>Featured</b> upgrades help your listings rank higher in the search results.",
      details: "View upgrades available",
    },
    filters: {
      label: "Filters",
      organization: "Filter by agency, branch or agent name",
      listingStatus: { title: "Listing status" },
      listingTiers: { title: "All listing tiers " },
      qualityStatus: { title: "Quality" },
      locationDistricts: { title: "All districts" },
      locationEstates: { title: "All locations" },
      location: { title: "All location" },
      column: { title: "Table column" },
      agency: { title: "Agency" },
      branch: { title: "Branch" },
      agents: { title: "Agents" },
      estate: { title: "Search by district or estate names" },
      listing: { title: "Search city, project or building names" },
      userFilter: { title: "Hierarchy", 1: "All agents", 2: "All branches" },
    },
    details: {
      title: "Performance details",
    },
    table: {
      listings: {
        id: "ID",
        listingId: "Listing ID",
        propertyNo: "Property No",
        statusCode: "Status",
        status: "Status",
        channel: "Channel",
        districtEstate: "District - Estate",
        price: "Price (RM)",
        upgrade: "Upgrade",
        quality: "Quality",
        dayOnSite: "Days on site",
        state: "State",
        city: "City",
        township: "Township-Building",
        area: "City - Building",
        building: "Building",
        listingdetails: "Listing details",
        districtEstateAndPrice: "District - Estate, Price (HK$)",
        primaryAgent: "Primary agent",
      },
      districts: {
        state: "State",
        area: "City",
        name: "District",
        totalListings: "Total listings",
      },
      estate: {
        state: "State",
        area: "City",
        name: "Estate",
        building: "Building",
        township: "Township",
        totalListings: "Total listings",
      },
      township: {
        state: "State",
        city: "City",
        name: "Township",
        building: "Building",
        totalListings: "Total listings",
      },
      user: {
        agentId: "Agent ID",
        branchId: "Branch ID",
        branch: "Branch",
        agentName: "Agent name",
        branchName: "Branch name",
        totalListings: "Total listings",
      },
      default: {
        impressions: "{short, plural, =1 {Imps} other {Impressions}}",
        pageViews: "Page views",
        enquiries: "Enquiries",
      },
      marketComparisonTooltip:
        'Your listing has <span class="negativePercentage">{percentage}% lower</span> {type} compared to other listings in the city.',
      columns: {
        id: "Listing ID",
        status: "Status",
        channel: "Channel",
        locationLevel1: "State",
        locationLevel2: "City",
        locationLevel3: "Township",
        locationLevel3Building: "Township-Building",
        locationLevel5: "Building",
        totalListings: "Total listings",
        price: "Price",
        product: "Upgrade",
        daysOnSite: "Days on site",
        impressions: "Impressions",
        pageViews: "Page views",
        enquiries: "Enquiries",
      },
    },
  },
};
